module.exports = __webpack_public_path__ + "static/img/Home61@2x.445f95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home61@2x.png
// module id = Nryh
// module chunks = 1